import { memo } from "react";
import { CopyButton } from "@/components/ui/copy-button";
import { effectiveCpm, formatCpm } from "@/lib/cpm";
import { currencySymbol } from "@/lib/format";

interface PriceColumnCellProps {
  negotiatedPrice?: number | string | null;
  currency?: string;
  medianViews?: number;
  deliverables?: number | null;
}

function PriceColumnCell({
  negotiatedPrice,
  currency,
  medianViews,
  deliverables,
}: PriceColumnCellProps) {
  if (negotiatedPrice == null || negotiatedPrice === "") {
    return <span className="text-muted-foreground text-xs italic">missing</span>;
  }

  const cpm = effectiveCpm(negotiatedPrice, medianViews, deliverables);

  return (
    <div className="flex items-center justify-between group min-w-0">
      <div className="flex flex-col items-start justify-center pl-1.5 border-l border-dashed min-w-0">
        {cpm != null && (
          <span className="text-muted-foreground font-mono uppercase text-[11px] leading-4 truncate max-w-full">
            {formatCpm(cpm, currency)}
          </span>
        )}
        <span className="text-sm truncate max-w-full">
          {currencySymbol(currency)}
          {negotiatedPrice}
        </span>
      </div>
      <CopyButton
        buttonText=""
        tooltipText="Copy price"
        textToCopy={String(negotiatedPrice)}
        variant="ghost"
        className="opacity-0 group-hover:opacity-100 size-8 shrink-0 text-muted-foreground"
        tooltipDelay={750}
      />
    </div>
  );
}

export default memo(PriceColumnCell);
